import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {isDefined} from "../../libs/utils/epic.utils";

export class DateStruct {

  public readonly day?: number;
  public readonly month?: number;
  public readonly year?: number;

  constructor(init?: Partial<DateStruct>) {
    Object.assign(this, init);
  }

  public toDate(): Date | undefined {
    if (isDefined(this.year) && isDefined(this.month) && isDefined(this.day)) {
      return new Date(this.year, this.month - 1, this.day);
    }
    return undefined;
  }

  public static fromDate(date: Date): DateStruct {
    return new DateStruct({
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear()
    });
  }

  public static fromNgbDate(ngb: NgbDateStruct): DateStruct {
    return new DateStruct({day: ngb.day, month: ngb.month, year: ngb.year});
  }
}
